export const booking_stays = {
  booking_stays_search_refresh_click: {
    category: "Booking - Stays",
    action: "User clicks to refresh stays search results",
    label: "booking-stays-refresh-click",
  },

  booking_stays_preferences_click: {
    category: "Booking stays preferences",
    action: "User opens stays preferences",
    label: "booking-stays-pref-click",
  },
  booking_stays_preferences_refundable: {
    category: "Booking stays preferences",
    action: "User interacts with refundable options",
    label: "stays-pref-refundable-option-click",
  },
  booking_stays_preferences_user_rating: {
    category: "Booking stays preferences",
    action: "User interacts with user rating filter",
    label: "stays-pref-user-rating-option-click",
  },
  booking_stays_preferences_star_rating_number: {
    category: "Booking stays preferences",
    action: "User selects star rating number",
    label: "stays-pref-star-rating-slct-opt-click",
  },

  booking_stays_preferences_types_hotels: {
    category: "Booking stays preferences",
    action: "User selects Hotels type",
    label: "stays-pref-types-select-click",
  },
  stays_pref_star_rating_deslct_opt_click: {
    category: "Stays Preferences",
    action: "User deselects star rating option in stays preferences",
    label: "stays-pref-star-rating-deslct-opt-click",
  },
  stays_pref_types_deselect_click: {
    category: "Stays Preferences",
    action: "User deselects stay type option",
    label: "stays-pref-types-deselect-click",
  },
  stays_pref_brands_option_click: {
    category: "Stays Preferences",
    action: "User selects a hotel brand option",
    label: "stays-pref-brands-option-click",
  },
  stays_pref_brands_clear: {
    category: "Stays Preferences",
    action: "User clears selected hotel brands",
    label: "stays-pref-brands-clear",
  },

  booking_stays_preferences_hotel_brands_input_click: {
    category: "Booking stays preferences",
    action: "User interacts with hotel brands input",
    label: "stays-pref-brands-input-click",
  },
  booking_stays_preferences_close: {
    category: "Booking stays preferences",
    action: "User closes preferences modal",
    label: "stays-pref-close-click",
  },
  booking_stays_preferences_done_click: {
    category: "Booking stays preferences",
    action: "User clicks Done in preferences",
    label: "stays-pref-done-click",
  },

  booking_stays_rooms_click: {
    category: "Booking stays rooms",
    action: "User opens rooms modal",
    label: "booking-form-stays-rooms-click",
  },
  booking_form_flights_view: {
    category: "Booking Form – Flights",
    action: "User views flights booking form",
    label: "booking-form-flights-view",
  },
  booking_form_stays_view: {
    category: "Booking Form – Stays",
    action: "User views stays booking form",
    label: "booking-form-stays-view",
  },
  booking_stays_rooms_adults_remove_click: {
    category: "Booking stays rooms",
    action: "User removes an adult",
    label: "booking-form-stays-rooms-adults-rmv",
  },
  booking_stays_rooms_adults_add_click: {
    category: "Booking stays rooms",
    action: "User adds an adult",
    label: "booking-form-stays-rooms-adults-add",
  },
  booking_stays_rooms_children_add: {
    category: "Booking stays rooms",
    action: "User adds a child",
    label: "booking-form-stays-rooms-children-add",
  },
  booking_stays_rooms_children_remove: {
    category: "Booking stays rooms",
    action: "User removes a child",
    label: "booking-form-stays-rooms-children-rmv",
  },
  booking_stays_rooms_add_another_room_click: {
    category: "Booking stays rooms",
    action: "User adds another room",
    label: "booking-form-stays-rooms-add-room-click",
  },
  booking_stays_rooms_remove_click: {
    category: "Booking stays rooms",
    action: "User removes a room",
    label: "booking-form-stays-rooms-rmv-room-click",
  },
  booking_stays_rooms_done_click: {
    category: "Booking stays rooms",
    action: "User clicks Done in rooms modal",
    label: "booking-form-stays-rooms-save-click",
  },

  booking_stays_location_input_click: {
    category: "Booking stays search",
    action: "User interacts with location input",
    label: "booking-form-stays-location-input-click",
  },
  booking_stays_checkin_date_click: {
    category: "Booking stays search",
    action: "User selects check-in date",
    label: "booking-form-stays-calendar-date-click",
  },
  booking_stays_checkout_date_click: {
    category: "Booking stays search",
    action: "User selects check-out date",
    label: "booking-form-stays-calendar-date-click",
  },
  booking_form_stays_rooms_cancel_click: {
    category: "Booking Form – Stays",
    action: "User cancels stays rooms selection",
    label: "booking-form-stays-rooms-cancel-click",
  },
  booking_form_stays_location_clear: {
    category: "Booking Form – Stays",
    action: "User clears stays location input",
    label: "booking-form-stays-location-clear",
  },
  booking_form_stays_location_option_click: {
    category: "Booking Form – Stays",
    action: "User selects a location option for stays",
    label: "booking-form-stays-location-option-click",
  },

  booking_stays_add_a_stay_click: {
    category: "Booking stays search",
    action: "User adds a stay",
    label: "booking-form-stays-add-a-stay-click",
  },
  booking_stays_remove_a_stay_click: {
    category: "Booking stays search",
    action: "User removes a stay",
    label: "booking-form-stays-rmv-a-stay-click",
  },

  booking_stays_select_room_btn_click: {
    category: "Booking stays hotel selection",
    action: "User clicks on select room button",
    label: "booking-stays-select-rooms-click",
  },
  selectStays: {
    category: "Booking stays hotel selection",
    action: "User clicks on select room button",
    label: "selectStays",
  },
  booking_stays_select_room_close_click: {
    category: "Booking stays hotel selection",
    action: "User closes select room modal",
    label: "booking-stays-select-rooms-close-click",
  },

  booking_stays_view_hotel_map: {
    category: "Booking stays hotel details",
    action: "User views hotel map",
    label: "bookings-stays-details-map-open-click",
  },

  booking_stays_view_hotel_map_close: {
    category: "Booking - Stays",
    action: "User closes hotel map view",
    label: "bookings-stays-details-map-close-click",
  },
  booking_stays_view_hotel_map_zoom_in: {
    category: "Booking - Stays",
    action: "User zooms in on hotel map",
    label: "booking-stays-details-map-zoom-in-click",
  },
  booking_stays_view_hotel_map_zoom_out: {
    category: "Booking - Stays",
    action: "User zooms out on hotel map",
    label: "booking-stays-details-map-zoom-out-click",
  },

  booking_stays_view_all_amenities: {
    category: "Booking stays hotel details",
    action: "User views all amenities",
    label: "bookings-stays-amenities-open-click",
  },
  booking_stays_view_room_details: {
    category: "Booking stays room details",
    action: "User views room details",
    label: "booking-stays-room-details-open-click",
  },
  booking_stays_view_room_details_close: {
    category: "Booking stays room details",
    action: "User closes room details modal",
    label: "booking-stays-room-details-close-click",
  },
  booking_stays_view_more_rates: {
    category: "Booking stays rates",
    action: "User views more room rates",
    label: "booking-stays-more-rates-click",
  },
  booking_stays_view_refundable_policies: {
    category: "Booking stays policies",
    action: "User views refundable policies",
    label: "booking-stays-cancel-policy-open-click",
  },
  booking_stays_view_refundable_policies_close: {
    category: "Booking stays policies",
    action: "User closes refundable policies modal",
    label: "booking-stays-cancel-policy-close-click",
  },
};
